import React from "react";
import PropTypes from "prop-types";
import IntlTelInput from "@intl-tel-input/react/with-utils";

import "intl-tel-input/styles";

import "./PhoneInput.scss";

const initialCountryLookup = async () => {
  const res = await fetch("https://ipapi.co/json");
  const data = await res.json();
  return data.country_code;
};

function PhoneInput({
  value,
  onChange,
  id,
  name,
  className,
  "data-testid": dataTestId,
  inputProps,
  disabled,
  readOnly,
}) {
  const intlRef = React.useRef(null);

  React.useEffect(() => {
    const instance = intlRef.current?.getInstance?.();
    const input = intlRef.current?.getInput?.();

    if (!instance || !input) {
      return;
    }

    const nextValue = value ?? "";
    if (input.value !== nextValue) {
      instance.setNumber(nextValue);
    }
  }, [value]);

  const mergedInputProps = {
    ...inputProps,
    id: inputProps?.id || id,
    name: inputProps?.name || name,
    className: [inputProps?.className, className].filter(Boolean).join(" "),
    "data-testid": dataTestId || inputProps?.["data-testid"],
  };

  return (
    <IntlTelInput
      ref={intlRef}
      initialCountryLookup={initialCountryLookup}
      allowedNumberTypes={["FIXED_LINE", "MOBILE", "FIXED_LINE_OR_MOBILE", "PREMIUM_RATE", "SHARED_COST"]}
      formatAsYouType={false}
      initialCountry="us"
      numberDisplayFormat="E164"
      placeholderNumberPolicy="OFF"
      strictRejectAnimation={false}
      value={value ?? ""}
      onChangeNumber={onChange}
      disabled={disabled}
      readOnly={readOnly}
      inputProps={mergedInputProps}
    />
  );
}

PhoneInput.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  "data-testid": PropTypes.string,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default PhoneInput;